// extracted by mini-css-extract-plugin
module.exports = {"container":"InformationIcons_container__2_602","text":"InformationIcons_text__2G5jo","icons":"InformationIcons_icons__3w0BH"};